import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { ADMIN_DASHBOARD_ROUTE } from "../../routes/RoutesPathes";

export const RedirectIfAuth = () => {
  const { auth } = useAuth();
  const location = useLocation();
  
  // If authenticated, redirect to either:
  // 1. The original 'from' location (if exists)
  // 2. Default dashboard
  return auth?.email ? (
    <Navigate 
      to={location.state?.from?.pathname || ADMIN_DASHBOARD_ROUTE} 
      replace 
    />
  ) : (
    <Outlet />
  );
};

export default RedirectIfAuth;
